import React, { useEffect, useState } from 'react'

import './ToggleButton.css'

export const ToggleButton = ({
  onChange,
  checked,
  className,
  label,
  iconClassName,
  labelClassName,
  checkOnClick = true,
  disabled = false
}) => {
  const [isChecked, setIsChecked] = useState(checked)

  useEffect(() => {
    setIsChecked(checked)
  }, [checked])

  const handleChecked = () => {
    if (checkOnClick) {
      setIsChecked(!isChecked)
    }
    onChange(!isChecked)
  }

  return (
    <div
      onClick={handleChecked}
      disabled={disabled}
      className={`toggle-btn ${className} ${isChecked ? 'checked' : ''} ${
        disabled ? 'disabled' : ''
      }`}
    >
      {iconClassName && <i className={`icon ${iconClassName}`} />}
      <div className={`toggle-label ${labelClassName}`}>{label}</div>
    </div>
  )
}

export default ToggleButton
